import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import StarSlotsIMG from "../img/starslots_001.jpg";
import PolarBearFrenzyIMG from "../img/polarbearfrenzy_001.png";
import PrayerHelperIMG from "../img/prayerhelper_001.png";
import DontGetStabbedIMG from "../img/dontgetstabbed_001.jpg";
import PizzaDeliverySurvivorsIMG from "../img/pizzadeliverysurvivors_001.jpg";
import DuluthcomIMG from "../img/duluth_001.jpg";
import rotaryIMG from "../img/rotary_001.jpg";
import steppermotorIMG from "../img/steppermotor_001.jpg";
import ragomaticIMG from "../img/ragomatic_001.png";
import thumbnailIMG from "../img/thumbnail.jpg";
import Row from "react-bootstrap/Row";

const projectData = [
  {
    title: "RAG-O-MATIC",
    desc: `An interactive educational tool that visualizes the Retrieval-Augmented Generation (RAG) pipeline step-by-step. Watch as documents are chunked, converted to embeddings, and used to answer questions with real-time cost tracking. Built with Next.js, TypeScript, and OpenAI API.`,
    footerText1: "Live Demo",
    footerURL1: "http://ragomatic.myked.com/",
    
    img: ragomaticIMG,
    alt: "RAG-O-MATIC - Interactive RAG pipeline visualization tool",
    technologies: ["Next.js", "TypeScript", "TailwindCSS", "Framer Motion", "OpenAI API", "RAG Systems", "Vector Embeddings", "Semantic Search"]
  },
  {
    title: "Pizza Delivery Survivors",
    desc: `Deliver pizzas in a zombie apocalypse with Pizza Delivery Survivors, created using Godot 4. Dodge zombies, use whimsical weapons, and survive the chaos. Currently in development, with a demo available now at the link below.`,
    footerText1: "Live Demo",
    footerURL1: "https://pizzadeliverysurvivors.com",
    footerText2: "",
    footerURL2: "",
    img: PizzaDeliverySurvivorsIMG,
    alt: "Pizza Delivery Survivors - Zombie apocalypse pizza delivery game screenshot",
    technologies: ["Godot 4", "Game Development", "Zombie Survival"]
  },
  {
    title: "PrayerHelper.faith",
    desc: `Craft personalized prayers with Prayer Helper - a free web app built with React, Next.js, and GPT language models. No matter your faith, find your voice in prayer with our six simple questions.`,
    footerText1: "Live Site",
    footerURL1: "https://PrayerHelper.faith",
    footerText2: "",
    footerURL2: "",
    img: PrayerHelperIMG,
    alt: "PrayerHelper.faith - AI-powered prayer crafting application",
    technologies: ["React", "Next.js", "GPT", "Spiritual Technology"]
  },
  {
    title: "Polar Bear Frenzy",
    desc: `Polar Bear Frenzy! A Canvas game made with Javascript. Play as a polar bear trying to get fish for their family while dodging pesky penguins. Controls: left/right arrows for movement, up arrow to jump, down arrow for claw attack.`,
    footerText1: "Live Site",
    footerURL1: "http://www.myke.wtf/polarbearfrenzy/",
    footerText2: "Github Repo",
    footerURL2: "https://github.com/gr0m17/polarbearfrenzy",
    img: PolarBearFrenzyIMG,
    alt: "Polar Bear Frenzy - Canvas-based polar bear fishing game",
    technologies: ["JavaScript", "Canvas", "HTML5 Games", "Browser Games"]
  },
  {
    title: "Don't Get Stabbed",
    desc: `An interactive video experience I originally created for use with YouTube annotations. I recently remastered the experience with React, creating an engaging choose-your-own-adventure style interactive story.`,
    footerText1: "Live Site",
    footerURL1: "http://www.dontgetstabbed.online",
    footerText2: "Github Repo",
    footerURL2: "https://github.com/gr0m17/dontgetstabbed",
    img: DontGetStabbedIMG,
    alt: "Don't Get Stabbed - Interactive video experience screenshot",
    technologies: ["React", "Interactive Video", "Choose Your Own Adventure"]
  },
  {
    title: "Star Slots",
    desc: `A Stardew Valley inspired slot machine I built in React with an integrated global leaderboard. Features pixel art graphics and farming-themed symbols for an authentic Stardew Valley experience.`,
    footerText1: "Live Demo",
    footerURL1: "https://starslots.surge.sh/",
    footerText2: "Github Repo",
    footerURL2: "https://github.com/gr0m17/star_slots",
    img: StarSlotsIMG,
    alt: "Star Slots - Stardew Valley themed slot machine game",
    technologies: ["React", "Slot Machine", "Stardew Valley", "Leaderboard"]
  },
  {
    title: "Duluth.com",
    desc: `Duluth.com was a lifestyle website I developed with WordPress. In the first 12 months grew monthly pageviews to 30,000+ through strategic content marketing and local SEO optimization.`,
    footerText1: "site is now defunct.",
    footerURL1: "https://duluth.com",
    footerText2: "",
    footerURL2: "",
    img: DuluthcomIMG,
    alt: "Duluth.com - Lifestyle website with 30k+ monthly pageviews",
    technologies: ["WordPress", "Content Marketing", "Local SEO", "Lifestyle Media"]
  },
  {
    title: "Rotary Cellphone",
    desc: `I turned a Rotary telephone into a cellphone using a 3g chipset and an arduino. This innovative hardware hack combines vintage aesthetics with modern mobile technology, creating a unique communication device.`,
    footerText1: "Video Demo",
    footerURL1: "https://myke.wtf/adafruit_interview/",
    footerText2: "Github Repo",
    footerURL2: "https://github.com/gr0m17/rotary_cellphone_dialer",
    img: rotaryIMG,
    alt: "Rotary Cellphone - Vintage rotary phone converted to mobile phone",
    technologies: ["Arduino", "3G Chipset", "Hardware Hacking", "Vintage Tech"]
  },
  {
    title: "The Stepper Motor Music Machine",
    desc: `I turned 8 Stepper motors, a custom designed and 3d printed mount, and 2 stepper controllers into an 8 voice music machine. 75k followers and growing on TikTok, showcasing the intersection of music and robotics.`,
    footerText1: "Asgore Theme from Undertale",
    footerURL1:
      "https://www.tiktok.com/@steppermotor/video/7515919693371231519",
    footerText2: "TikTok profile",
    footerURL2: "https://www.tiktok.com/@steppermotor",
    img: steppermotorIMG,
    alt: "Stepper Motor Music Machine - 8-voice robotic music instrument",
    technologies: ["Stepper Motors", "3D Printing", "Robotics", "Music Technology", "TikTok"]
  },
];

export default function Projects() {
  return (
    <div id="projects" style={{ paddingTop: "10vh", paddingBottom: "5vh" }}>
      <Container>
        <p className="text-center align-middle display-1 p-3">
          Recent Projects
        </p>
        <Row className="g-3" xs={1} sm={1} md={2} lg={2} xl={3}>
          {projectData.map((project, index) => {
            return (
              <Col key={project.title || index}>
                <Card className="h-100">
                  <a href={project.footerURL1}>
                    <Card.Img variant="top" src={project.img} alt={project.alt} />
                  </a>
                  <Card.Body>
                    <Card.Title>{project.title}</Card.Title>
                    <Card.Text>{project.desc}</Card.Text>
                    <div className="mt-2">
                      {project.technologies && project.technologies.map((tech, techIndex) => (
                        <span key={techIndex} className="badge bg-secondary me-1 mb-1">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </Card.Body>
                  <Card.Footer>
                    <Card.Link href={project.footerURL1}>
                      {project.footerText1}
                    </Card.Link>
                    {project.footerText2 && (
                      <Card.Link href={project.footerURL2}>
                        {project.footerText2}
                      </Card.Link>
                    )}
                  </Card.Footer>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}
